// extracted by mini-css-extract-plugin
export default {"primary":"ServerDetails_primary__5DMmS","primaryBackground":"ServerDetails_primaryBackground__Iyhvp"};